import { render, staticRenderFns } from "./IdCardButtonBe.vue?vue&type=template&id=706e58f9&"
import script from "./IdCardButtonBe.vue?vue&type=script&lang=js&"
export * from "./IdCardButtonBe.vue?vue&type=script&lang=js&"
import style0 from "./IdCardButtonBe.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports